import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useAuthContext } from './AuthContextProvider'

interface UseResumeWalkProps {
  isAuthComplete: boolean
  tryToResume: boolean
  progressSlug?: string | null
}

const useResumeWalk = ({
  isAuthComplete,
  tryToResume,
  progressSlug,
}: UseResumeWalkProps): void => {
  const router = useRouter()
  const { isFreshSession, setIsFreshSession } = useAuthContext()

  useEffect(() => {
    if (isAuthComplete && isFreshSession) {
      if (tryToResume && progressSlug) {
        router.replace(progressSlug).finally(() => setIsFreshSession(false))
      } else {
        setIsFreshSession(false)
      }
    }
  }, [
    isAuthComplete,
    isFreshSession,
    progressSlug,
    router,
    setIsFreshSession,
    tryToResume,
  ])
}

export default useResumeWalk
